import React, { useRef } from "react";
import { useDnD } from "../DnD_component/DnDContext";
import SvgImageRow from "../Node_Edge Components/Stencils/SvgImageRow";
import { useState, useEffect } from "react";
import "../Side Bar Component/SideBar.css";
import closeIcon from "../../Assets/popup-close.svg";
import searchIcon from "../../Assets/add_candidate_info.svg";
import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateservice";
import EventServiceController from "../../Controllers/EventService";
import { Clear, Search } from "@mui/icons-material";
// import html2canvas from 'html2canvas';
import SvgImageRowSub from "../Node_Edge Components/Stencils/SvgImageRowSub";

const Sidebar = ({ workflow, createEvent, selectedEventLevel }) => {
  const [_, setType] = useDnD();
  // const [imageSrc, setImageSrc] = useState('');
  const subflowSidebarRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [allSvgVisible, setAllSvgVisible] = useState(false);
  const [subflowLegend, setSubflowLegend] = useState([]);
  const eventCont = new EventServiceController();
  const [pageLoaded, setPageLoaded] = useState(false);

  const getLegends = async () => {
    if (!workflow) {
      const body = await eventCont.getPrimaryEventsList();
      if (Array.isArray(body) && body.length > 0) {
        const uniqueTypes = Array.from(
          new Set(body.map((item) => item.typeName))
        ).map((typeName) => {
          const item = body.find((item) => item.typeName === typeName);
          return { name: typeName, color: item.typeColor };
        });
        if (subflowSidebarRef.current) {
          setSubflowLegend(subflowSidebarRef.current.legend);
        }

      }
    }
  }
  useEffect(() => {
    getLegends();
    setPageLoaded(true); // Update state to trigger re-render
  }, [pageLoaded]);

  const onDragStart = (event, nodeType, data, level, levelId) => {
    setType(nodeType, level);
    event.dataTransfer.effectAllowed = "move";
    // If data is provided (from dropdown), don't overwrite it
    if (!event.dataTransfer.types.includes("application/reactflow")) {
      if (data) {
        event.dataTransfer.setData(
          "application/reactflow",
          JSON.stringify(data)
        );
      } else {
        event.dataTransfer.setData("application/reactflow", nodeType, level);
        event.dataTransfer.setData("level", level);
        event.dataTransfer.setData("levelId", levelId);
      }
    }
  };


  const workflowTempCont = new WorkflowTemplateServiceController();
  const [workflowLevelComp, setWorkflowLevelComp] = useState([]);
  const getSidebarLevelComponents = async () => {
    const body = await workflowTempCont.getSidebarComponents();
    setWorkflowLevelComp(
      Array.isArray(body) && body.length > 0 ?
        body.map((levelComp, index) => ({
          id: levelComp.id,
          levelCode: levelComp.levelCode,
          levelName: levelComp.levelName,
          mappedsubflowId: levelComp.mappedSubflowId,
        })
        )
        :
        []
    )
  }

  useEffect(() => {
    if (workflow) {
      getSidebarLevelComponents();
    }
  }, [workflow])
  const handleChange = (event) => {
    setSearchText(event.target.value);
  };
  const selectedSvg = () => {
    setAllSvgVisible(false);
    setSearchText('');
  }
  const expandedSvg = () => {
    setAllSvgVisible(true);
  }
  const handleSearchClear = () => {
    setSearchText('');
  }
  var Spinner = require('react-spinkit');
  //const levels=['L1','L2','L3A','L3B','L4','L5','L6',];
  return (
    <div className="sidebar">
      {
        workflow ?
          <>
            <p className="heading">Workflow Template </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'start', height: 'auto', width: '100%', marginTop: '5px', padding: '5px' }}>
              {
                workflowLevelComp.length > 0 ?
                  workflowLevelComp.map((comp, index) => (
                    <div
                      style={{ height: '50px', width: '50px', borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px' }}
                      draggable
                      onDragStart={(event) => onDragStart(event, "subflowNode", null, comp.levelName, comp.id)}
                    >
                      <p style={{ fontSize: '18px', color: '#757ea5', fontWeight: '600' }}>{comp.levelName}</p>
                    </div>
                  )) :
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', marginTop: '25px' }}>
                    <Spinner name="ball-spin-fade-loader" color="#fff" />
                  </div>

              }
            </div>
          </>
          :
          <>
            {/* <p className="heading"> Process </p>
            <div className="processRow">
              <div
                className="process_shape_background"
                draggable
                onDragStart={(event) => onDragStart(event, "rectangle", null)}
              >
                <div
                  style={{ backgroundColor: "white", height: "30px", width: "75px" }}
                ></div>
                <p style={{ fontSize: "14px", color: "white" }}>Rectangle</p>
              </div>
              <div
                className="process_shape_background"
                draggable
                onDragStart={(event) => onDragStart(event, "oval", null)}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: "30px",
                    width: "75px",
                    borderRadius: "30px",
                  }}
                ></div>
                <p style={{ fontSize: "14px", color: "white" }}>Oval</p>
              </div>
            </div>
            <div className="processRow">
              <div
                className="process_shape_background"
                draggable
                onDragStart={(event) => onDragStart(event, "diamond", null)}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: "50px",
                    width: "50px",
                    clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)",
                  }}
                ></div>
                <p style={{ fontSize: "14px", color: "white" }}>Diamond</p>
              </div>
              <div
                className="process_shape_background"
                draggable
                onDragStart={(event) => onDragStart(event, "parallelogram", null)}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: "35px",
                    width: "75px",
                    clipPath: "polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)",
                  }}
                ></div>
                <p style={{ fontSize: "14px", color: "white" }}>Parallelogram</p>
              </div>
            </div> */}
            <p className="heading"> Event </p>

            {/* {allSvgVisible && ( */}
            <div className="search-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #cfd4e9', borderRadius: '4px', opacity: 1, background: 'white' }}>
              <input
                type="text"
                value={searchText}
                onChange={handleChange}
                className="input-search"
                placeholder="search..."
              />
              {/* <img src={searchText === ''? searchIcon : closeIcon} alt="search-icons" onClick={searchText !== '' ? handleSearchClear : null } /> */}
              {(searchText === '' || searchText === undefined) ? <Search style={{ color: '#757ea5' }} /> : <Clear style={{ color: '#757eas' }} onClick={handleSearchClear} sx={{ cursor: 'pointer' }} />}
            </div>
            {/* )} */}

            <div
              className="icon"
              onDragStart={(event) => onDragStart(event, "icon", null)}
              draggable={false}
              style={{ width: "100%", height: "100%",   overflow: "auto" }}
            >
              <SvgImageRowSub searchText={searchText} selectedSvg={selectedSvg} expandedSvg={expandedSvg} ref={subflowSidebarRef} createEvent={createEvent} selectedEventLevel={selectedEventLevel} />
            </div>

            {/* <div>
       <button onClick={handleSave}>Save</button>
      </div>    
      <div style={{height:'100%',width:'100%', backgroundColor:'#121b45'}}>
<img src={imageSrc} alt='dataimage' height='50%' width='100%' />
      </div> */}
          </>
      }

      {
        // (!workflow && subflowLegend.length > 0) && (
        //   <div style={{ position: 'relative', width: 'auto', height: 'auto', background: '#fff', marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px ', }}>
        //     {subflowLegend.map((legend, index) => (
        //       <div
        //         style={{ display: "flex", gap: "5px", alignItems: "center" }}
        //         key={index}
        //       >
        //         <div
        //           style={{
        //             height: "10px",
        //             width: "15px",
        //             borderRadius: "50%",
        //             background: legend.color,
        //           }}
        //         ></div>
        //         <p>{legend.name}</p>
        //       </div>
        //     ))}
        //   </div>
        // )
      }

    </div>
  );
};
export default Sidebar;
